"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ShareCartState_1 = require("./ShareCartState");
var localStyles = require("./ShareCart.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var ShareCart_cms_1 = require("./ShareCart.cms");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var ReportingService_1 = require("../../../../api/ReportingService");
var Api_1 = require("../../../../api/Api");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var cartUtils = require("../../../../utils/CartUtilFunctions");
var components_1 = require("@idp/duc/components");
var ShareCart = /** @class */ (function (_super) {
    __extends(ShareCart, _super);
    function ShareCart(props) {
        var _this = _super.call(this, props) || this;
        _this.baseURL = '';
        _this.shareCartLink = '';
        _this.EMAIL_PROTOCOL = 'mailto';
        _this.SMS_PROTOCOL = 'sms';
        _this.displayEmailButton = false;
        _this.displaySMSButton = false;
        _this.displayCopyButton = false;
        _this.state = new ShareCartState_1.default();
        _this.bindAll();
        _this.getShareCartCMS();
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    ShareCart.prototype.componentDidMount = function () {
        if (window && window.location) {
            this.baseURL = window.location.protocol + "//" + window.location.host;
        }
    };
    ShareCart.prototype.bindAll = function () {
        this.openShareCartModal = this.openShareCartModal.bind(this);
        this.closeShareCartModal = this.closeShareCartModal.bind(this);
        this.getShareCartCMS = this.getShareCartCMS.bind(this);
        this.rendershareCartModal = this.rendershareCartModal.bind(this);
        this.renderEmailShare = this.renderEmailShare.bind(this);
        this.renderTextShare = this.renderTextShare.bind(this);
        this.shareCartByEmail = this.shareCartByEmail.bind(this);
        this.shareCartByText = this.shareCartByText.bind(this);
        this.copyToClipBoard = this.copyToClipBoard.bind(this);
        this.renderLinkCopiedText = this.renderLinkCopiedText.bind(this);
        this.displayLinkCopiedTextMessage = this.displayLinkCopiedTextMessage.bind(this);
        this.setDisplayButtonStatus = this.setDisplayButtonStatus.bind(this);
        this.getShareCartContent = this.getShareCartContent.bind(this);
    };
    ShareCart.prototype.render = function () {
        return (React.createElement("span", { className: localStyles.linkWithIcon },
            React.createElement(components_1.Link, { kind: "textPlain", onClick: this.openShareCartModal, className: CartConfiguration_scss_1.cartLinkMedium, testId: utils_1.default('Share', 'Cart', 'Link') }, this.shareCartCMS.shareLinkLabel),
            this.rendershareCartModal()));
    };
    ShareCart.prototype.rendershareCartModal = function () {
        this.setDisplayButtonStatus();
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('Share', 'Cart', 'Modal'), options: {
                center: true,
                className: { modalParentClass: localStyles.modalParent },
                show: this.state.showShareCartModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.SMALL,
            }, events: { onClose: this.closeShareCartModal } },
            React.createElement("div", { className: localStyles.headingContainer },
                React.createElement(ui_components_1.Label, { data: { text: this.shareCartCMS.shareCartModalHeading }, options: {
                        className: localStyles.legalHeading,
                        size: LabelProps_1.LabelSizes.MEDIUMHEADING,
                        tag: LabelProps_1.LabelTags.h1,
                    } })),
            React.createElement("div", { className: localStyles.shareCartDescription },
                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Share', 'Cart', 'Desc1'), data: { text: cartUtils.isSMBCustomer() ?
                            this.shareCartCMS.smbDescriptionLine1 : this.shareCartCMS.descriptionLine1 } })),
            cartUtils.isPreScreenCreditCheck() &&
                React.createElement("div", { className: localStyles.shareCartDescription },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Share', 'Cart', 'Desc2'), data: { text: this.shareCartCMS.descriptionLine2 } })),
            React.createElement("div", { className: localStyles.shareCartButton }, this.displayEmailButton && this.renderEmailShare()),
            React.createElement("div", { className: localStyles.shareCartButton }, this.displaySMSButton && this.renderTextShare()),
            this.state.displayLinkCopiedText &&
                React.createElement("div", null, this.renderLinkCopiedText()),
            React.createElement("div", { className: localStyles.shareCartButton }, this.displayCopyButton && this.renderCopyToClipBoard()),
            React.createElement("div", { className: localStyles.shareCartFooter },
                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Share', 'Cart', 'footer'), data: { text: this.shareCartCMS.shareCartModalFooter } }))));
    };
    ShareCart.prototype.renderEmailShare = function () {
        return (React.createElement("button", { className: localStyles.shareCartButtonCommon, onClick: this.shareCartByEmail, "data-test-id": utils_1.default('Share', 'Email', 'button'), formTarget: "_blank" },
            React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartEmailIcon, localStyles.iconStyle].join(' '), role: "img" }),
            this.shareCartCMS.emailCTALabel));
    };
    ShareCart.prototype.renderTextShare = function () {
        return (React.createElement("button", { className: localStyles.shareCartButtonCommon, onClick: this.shareCartByText, "data-test-id": utils_1.default('Share', 'Text', 'button') },
            React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartTextIcon, localStyles.iconStyle].join(' '), role: "img" }),
            this.shareCartCMS.textCTALabel));
    };
    ShareCart.prototype.renderCopyToClipBoard = function () {
        return (React.createElement("button", { className: localStyles.shareCartButtonCommon, onClick: this.copyToClipBoard, "data-test-id": utils_1.default('Share', 'Copy', 'button') },
            React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartCopyIcon, localStyles.iconStyle].join(' '), role: "img" }),
            this.shareCartCMS.copyLinkCTALabel));
    };
    ShareCart.prototype.renderLinkCopiedText = function () {
        return (React.createElement("div", { className: localStyles.linkCopiedBox },
            React.createElement("span", null,
                "\u2714 ",
                this.shareCartCMS.linkCopiedText)));
    };
    ShareCart.prototype.openShareCartModal = function () {
        var _this = this;
        this.reportingService.fireLinkClickWithOutPageLoad(this.shareCartCMS.shareLinkLabel, ReportingService_1.PageUrls.SHARE_CART_MODAL);
        this.api.getShareCartURL().then(function (response) {
            if (response && response.content && response.content.status &&
                response.content.status.toUpperCase() === 'SUCCESS' &&
                response.content.payload && response.content.payload.retrieveURL) {
                _this.shareCartLink = response.content.payload.retrieveURL;
                if (cartUtils.isSMBCustomer() && _this.shareCartLink) {
                    _this.shareCartLink = "" + _this.shareCartLink + '&smb=true';
                }
                _this.setState({ showShareCartModal: true });
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.SHARE_CART_MODAL);
            }
        });
    };
    ShareCart.prototype.closeShareCartModal = function () {
        this.setState({ showShareCartModal: false });
        this.reportingService.fireLinkClickThenPageloadEvent('close', ReportingService_1.PageUrls.CART_PAGE);
    };
    ShareCart.prototype.getShareCartCMS = function () {
        var shareCartCMS = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout');
        if (shareCartCMS && shareCartCMS.content &&
            shareCartCMS.content.shareCart) {
            this.shareCartCMS = shareCartCMS.content.shareCart;
        }
        else {
            this.shareCartCMS = new ShareCart_cms_1.ShareCartCms();
        }
    };
    ShareCart.prototype.shareCartByEmail = function () {
        var emailSubject = encodeURIComponent(this.shareCartCMS.sharedCartHeader);
        var emailBody1 = encodeURIComponent(this.getShareCartContent().headerContent) + "%0A%0A" + this.baseURL + encodeURIComponent(this.shareCartLink) + "%0A%0A";
        var emailBody = "" + emailBody1 + encodeURIComponent(this.getShareCartContent().footerContent);
        var emailLink = this.EMAIL_PROTOCOL + ":?subject=" + emailSubject + "&body=" + emailBody;
        this.reportingService.fireLinkClickWithOutDestination(this.shareCartCMS.emailCTALabel);
        if (window && window.location) {
            window.location.href = emailLink;
            return false;
        }
    };
    ShareCart.prototype.shareCartByText = function () {
        var textBody1 = encodeURIComponent(this.getShareCartContent().headerContent) + "%0A%0A" + this.baseURL + encodeURIComponent(this.shareCartLink) + "%0A%0A";
        var textBody = "" + textBody1 + encodeURIComponent(this.getShareCartContent().footerContent);
        var textLink = this.SMS_PROTOCOL + ":?&body=" + textBody;
        if (window && window.location) {
            window.location.href = textLink;
        }
        this.reportingService.fireLinkClickWithOutDestination(this.shareCartCMS.textCTALabel);
    };
    ShareCart.prototype.getShareCartContent = function () {
        var shareContent = {
            footerContent: this.shareCartCMS.shareCartModalFooter,
            headerContent: this.shareCartCMS.sharedCartHeader,
        };
        if (cartUtils.isSMBCustomer()) {
            shareContent.footerContent = this.shareCartCMS.smbsharedCartFooter;
            shareContent.headerContent = this.shareCartCMS.smbsharedCartDescription1;
        }
        return shareContent;
    };
    ShareCart.prototype.copyToClipBoard = function () {
        var _this = this;
        var urlLink = "" + this.baseURL + this.shareCartLink + '\n' + ("" + this.shareCartCMS.shareCartModalFooter);
        if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(urlLink).then(function () {
                _this.displayLinkCopiedTextMessage();
                if (navigator.vibrate) {
                    navigator.vibrate(100);
                }
            });
        }
        this.reportingService.fireLinkClickWithOutDestination(this.shareCartCMS.copyLinkCTALabel);
    };
    ShareCart.prototype.displayLinkCopiedTextMessage = function () {
        var _this = this;
        this.setState({ displayLinkCopiedText: true }, function () {
            setTimeout(function () {
                _this.setState({ displayLinkCopiedText: false });
            }, 3000);
        });
    };
    ShareCart.prototype.setDisplayButtonStatus = function () {
        this.displayEmailButton = true;
        this.displaySMSButton = cartUtils.isMobileUserAgent();
        this.displayCopyButton = navigator && navigator.clipboard ? true : false;
    };
    return ShareCart;
}(React.Component));
exports.default = ShareCart;
//# sourceMappingURL=ShareCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/ShareCart/ShareCart.js
// module id = 2337
// module chunks = 8